import React, { useEffect } from 'react';
import { STATUS_LABELS, STATUS_TONE } from './planApi';

export const Badge = ({ status, children, tone }) => (
  <span className={`pm-badge pm-badge--${tone || STATUS_TONE[status] || 'muted'}`}>
    {children || STATUS_LABELS[status] || status}
  </span>
);

export const Modal = ({ title, subtitle, onClose, children, footer, wide }) => {
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="pm-modal-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className={`pm-modal ${wide ? 'pm-modal--wide' : ''}`} role="dialog" aria-modal="true">
        <div className="pm-modal__head">
          <div>
            <h3>{title}</h3>
            {subtitle && <p>{subtitle}</p>}
          </div>
          <button className="pm-icon-btn" onClick={onClose} aria-label="Close">✕</button>
        </div>
        <div className="pm-modal__body">{children}</div>
        {footer && <div className="pm-modal__foot">{footer}</div>}
      </div>
    </div>
  );
};

export const ConfirmModal = ({ title, message, confirmLabel = 'Confirm', danger, busy, onConfirm, onClose, children }) => (
  <Modal
    title={title}
    onClose={onClose}
    footer={
      <>
        <button className="pm-btn pm-btn--ghost" onClick={onClose} disabled={busy}>Cancel</button>
        <button className={`pm-btn ${danger ? 'pm-btn--danger' : 'pm-btn--primary'}`} onClick={onConfirm} disabled={busy}>
          {busy ? 'Working…' : confirmLabel}
        </button>
      </>
    }
  >
    {message && <p className="pm-muted">{message}</p>}
    {children}
  </Modal>
);

export const Field = ({ label, hint, children, error }) => (
  <label className="pm-field">
    <span className="pm-field__label">{label}</span>
    {children}
    {hint && !error && <span className="pm-field__hint">{hint}</span>}
    {error && <span className="pm-field__error">{error}</span>}
  </label>
);

export const Toast = ({ toast }) =>
  toast ? <div className={`pm-toast pm-toast--${toast.type}`}>{toast.msg}</div> : null;

export const useToast = () => {
  const [toast, setToast] = React.useState(null);
  const timer = React.useRef(null);
  const show = React.useCallback((msg, type = 'success') => {
    clearTimeout(timer.current);
    setToast({ msg, type });
    timer.current = setTimeout(() => setToast(null), 3500);
  }, []);
  useEffect(() => () => clearTimeout(timer.current), []);
  return [toast, show];
};
